// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UShortValue implements flatbuffers.IUnpackableObject<UShortValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UShortValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUShortValue(bb: flatbuffers.ByteBuffer, obj?: UShortValue): UShortValue {
    return (obj || new UShortValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUShortValue(
    bb: flatbuffers.ByteBuffer,
    obj?: UShortValue,
  ): UShortValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UShortValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startUShortValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt16(0, value, 0);
  }

  static endUShortValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createUShortValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    UShortValue.startUShortValue(builder);
    UShortValue.addValue(builder, value);
    return UShortValue.endUShortValue(builder);
  }

  unpack(): UShortValueT {
    return new UShortValueT(this.value());
  }

  unpackTo(_o: UShortValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): UShortValueT {
    const t = new UShortValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class UShortValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return UShortValue.createUShortValue(builder, this.value);
  }

  clone(): UShortValueT {
    const obj = new UShortValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: UShortValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyUShortValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
